import { useDropdownContext } from './DropdownProvider.js';

var useDropdownTrigger = function (_a) {
    var _b = _a === void 0 ? {} : _a, onClick = _b.onClick;
    var context = useDropdownContext();
    var disabled = context.disabled, toggleIsOpen = context.toggleIsOpen, triggerRef = context.triggerRef, setIsOpen = context.setIsOpen;
    return {
        context: context,
        props: {
            "aria-haspopup": true,
            disabled: disabled,
            onfocus: function () { return setIsOpen(false); },
            onClick: function (event) {
                if (onClick)
                    onClick(event);
                !event.defaultPrevented && toggleIsOpen();
            },
            ref: triggerRef,
        },
    };
};

export { useDropdownTrigger };
//# sourceMappingURL=useDropdownTrigger.js.map
